import * as Model from '../types/document'
import { documentC } from 'src/globals';
import { Cursor } from 'src/lib/Cursor';
import * as actions from '../actions'

export function definitionById(definitionId: Model.DefinitionId): Cursor<Model.Definition> {
  return Cursor.selectPattern(documentC._('definitions'), {id: definitionId})
}

export function fixDocument(document: Model.Document): Model.Document {
  if (!document.scratch) {
    document = {...document, scratch: actions.makeNewBlock()}
  }
  return document
}


// WEBPACK FOOTER //
// ./src/model/document.ts